export default __webpack_public_path__ + "images/0xae4aa155d2987b454c29450ef4f862cf00907b61.png";